import React from 'react';
import type { FC } from 'react';
import { useDrop } from 'react-dnd';
import { PlayerBox } from './PlayerBox';
import { ItemTypes } from './ItemTypes';
import { ReactComponent as PlusIcon } from 'images/plus.svg';
import { PlayerName } from 'models/baseRunners/PlayerName';
import { LastDroppedPlayer } from 'models/baseRunners/LastDropperPlayer';
import { BaseItem, BaseWrapper } from './styles/BaseStyles';

export interface BaseProps {
  accept: string[];
  onDrop: (item: PlayerName, monitor?: any) => void;
  lastDroppedItem?: LastDroppedPlayer;
  id: string | number;
  onEmptyClick: () => void;
  draggingHandler: (isDragging: boolean) => void;
}

const Base: FC<BaseProps> = (props) => {
  const { accept, lastDroppedItem, onDrop, id, onEmptyClick, draggingHandler } = props;

  const [{ isOver, canDrop }, drop] = useDrop({
    accept,
    drop: onDrop,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const isActive = isOver && canDrop;
  let backgroundColor = 'rgba(0, 0, 0, 0.1)';
  if (isActive) {
    backgroundColor = 'darkgreen';
  } else if (canDrop) {
    backgroundColor = 'darkkhaki';
  }
  return (
    <BaseWrapper className={`base-${id} ${lastDroppedItem && 'with-player'}`}>
      <BaseItem className='base' onClick={() => !lastDroppedItem && onEmptyClick()} ref={drop} style={{ backgroundColor }}>
        {lastDroppedItem ? (
          <PlayerBox draggingHandler={draggingHandler} name={lastDroppedItem.name} type={ItemTypes.FirstBase} isDropped={false} key={0} />
        ) : (
          <PlusIcon />
        )}
      </BaseItem>
    </BaseWrapper>
  );
};

export default Base;
